import { Header } from "widgets";
import { HeroSection } from "widgets";
import { AboutSection } from "widgets";
import { ProductsSection } from "widgets";
import { BrandsSection } from "widgets";
import { NewsSection } from "widgets";
import { FormSection } from "widgets";
import { Footer } from "widgets";
import FormImg from "../assets/FormImg.jpg";
import styles from "./HomePage.module.scss";

export const HomePage = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageWrapper}>
        <Header />
        <div className={styles.pageWrapper__mainContent}>
          <div className={styles.section}>
            <HeroSection />
          </div>
          <div className={styles.section} id="blog">
            <NewsSection />
          </div>
          <div className={styles.section} id="products">
            <ProductsSection />
          </div>
          <div className={styles.section} id="brands">
            <BrandsSection title="Бренды" btnText="Все бренды" />
          </div>
          <div className={styles.section} id="about">
            <AboutSection />
          </div>
          <div className={styles.section}>
            <FormSection
              formTitle="Свяжитесь с нами по вопросу сотрудничества"
              formImg={FormImg}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
